import { render, staticRenderFns } from "./BookingSideMenu.vue?vue&type=template&id=58204162&scoped=true"
import script from "./BookingSideMenu.vue?vue&type=script&lang=js"
export * from "./BookingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./BookingSideMenu.vue?vue&type=style&index=0&id=58204162&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58204162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58204162')) {
      api.createRecord('58204162', component.options)
    } else {
      api.reload('58204162', component.options)
    }
    module.hot.accept("./BookingSideMenu.vue?vue&type=template&id=58204162&scoped=true", function () {
      api.rerender('58204162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingSideMenu.vue"
export default component.exports